import axios from "axios";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import * as actions from "../reducers/left";

function loadDataAPI(payload) {
  return axios.get(`/api/eh/main/side`, {
    params: { ...payload },
  });
}

function* loadData({ payload }) {
  console.log("payload: ============================== ", payload);
  console.log("loadData payload", payload);
  yield put({
    type: actions.LOADING,
    payload: true,
  });

  try {
    const response = yield call(loadDataAPI, payload);
    console.log("response: ", response);
    console.log("response.data.data: ", response.data.data);

    yield put({
      type: actions.LOAD_LEFT_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    console.log("error: ", error);
  }

  yield put({
    type: actions.LOADING,
    payload: false,
  });
}

function* watchLoadData() {
  yield takeEvery(actions.LOAD_LEFT, loadData);
}

export default function* leftSaga() {
  yield all([fork(watchLoadData)]);
}
